import { mapActions } from 'vuex';

export default {
	methods: {
		...mapActions('app', ['setPageLoadingAction']),
		showPageLoader() {
			this.setPageLoadingAction(true);
		},
		hidePageLoader() {
			this.setPageLoadingAction(false);
		}
	}
};
